import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface SelectedUserState {
  selectedUser: string;
  selectedUserData: {
    firstName: string;
    lastName: string;
    userCode: string;
    account_id: string;
    stock_account_id?: string;
    money_account_id?: string;
  } | null;
}

const initialState: SelectedUserState = {
  selectedUser: "",
  selectedUserData: null,
};

const selectedUserSlice = createSlice({
  name: 'selectedUser',
  initialState,
  reducers: {
    setSelectedUser(state, action: PayloadAction<string>) {
      state.selectedUser = action.payload;
    },
    setSelectedUserData(state, action: PayloadAction<SelectedUserState['selectedUserData']>) {
      state.selectedUserData = action.payload;
    },
    clearSelectedUser(state) {
      state.selectedUser = "";
      state.selectedUserData = null;
    },
  },
});

export const { setSelectedUser, setSelectedUserData, clearSelectedUser } = selectedUserSlice.actions;
export default selectedUserSlice.reducer;